module.exports = __webpack_public_path__ + "static/image/history/m/201103@3x.ver2_0_2.jpg?5af462f9";